import { X } from 'lucide-react'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { FeatureCarousel } from './FeatureCarousel'
import type { FeatureSlide } from './slides'

export interface WhatsNewTour {
  slides: readonly FeatureSlide[]
  onSlideViewed?: (featureId: string) => void
}

export function WhatsNewDialog({
  open,
  onOpenChange,
  trigger,
  tour,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  trigger?: ReactElement
  tour?: WhatsNewTour
}) {
  const { t } = useTranslation()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {trigger && <DialogTrigger asChild>{trigger}</DialogTrigger>}
      <DialogContent
        className="flex h-[min(46rem,calc(100dvh-2rem))] flex-col gap-0 overflow-hidden rounded-2xl p-0 sm:max-w-3xl motion-reduce:animate-none md:h-[min(46rem,90dvh)]"
        overlayClassName="bg-background/70 supports-backdrop-filter:backdrop-blur-md motion-reduce:animate-none"
      >
        <DialogTitle className="sr-only">{t('whatsNew.title')}</DialogTitle>
        <DialogDescription className="sr-only">{t('whatsNew.description')}</DialogDescription>
        <FeatureCarousel slides={tour?.slides} onSlideViewed={tour?.onSlideViewed} />
        <DialogClose asChild>
          <Button
            size="icon-sm"
            variant="ghost"
            className="absolute right-3 top-3 rounded-full text-muted-foreground max-md:size-9"
            aria-label={t('common.close')}
          >
            <X className="size-4" aria-hidden />
          </Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  )
}
